export default __webpack_public_path__ + "268786007dcaf1c752de4d68513fd103.png";